/* eslint-disable @next/next/no-img-element */
import EventImageCropperModal from "components/EventImageCropperModal";
import useMobile from "customHooks/useMobile";
import useTranslation from "next-translate/useTranslation";
import { memo, useEffect, useMemo, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";
import { FiRefreshCw } from "react-icons/fi";
import useModal from "../../../customHooks/useModal";
type Props = {
  editedImg?: string;
  isEditModal?: boolean;
};
const Step3 = ({ editedImg, isEditModal }: Props) => {
  const {
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();

  const { t } = useTranslation("common");
  const [avatar, setAvatar] = useState("");

  const [imagePreview, setImagePreview] = useState("");
  const onUploadBtnClick = (e) => {
    const file = e.target.files[0];

    if (file) {
      setAvatar(URL.createObjectURL(file));
      handleShowImageCropperModal();
    }
  };
  const {
    showModal: showImageCropperModal,
    handleCloseModal: handleCloseImageCropperModal,
    handleShowModal: handleShowImageCropperModal,
  } = useModal();

  const onImageSubmit = (data, croppedImg) => {
    setImagePreview(croppedImg);
    setValue("preview_image", data.get("avatar"), { shouldValidate: true });
    handleCloseImageCropperModal();
  };
  const imgPreview = watch("preview_image");

  useEffect(() => {
    let objectUrl = "";
    if (imgPreview) {
      const file = imgPreview;

      objectUrl = URL?.createObjectURL(file);
      setImagePreview(objectUrl);
    }
    return () => URL.revokeObjectURL(objectUrl);
  }, []);
  const isMobile = useMobile("md");

  const fileUploadRef = useRef(null);
  const uploadElement = useMemo(() => {
    return (
      <input
        ref={fileUploadRef}
        accept="image/png, image/gif, image/jpeg"
        type="file"
        onChange={onUploadBtnClick}
        hidden
        onClick={(event) => {
          // @ts-ignore
          event.target.value = null;
        }}
        className="file-drop-input"
      />
    );
  }, []);
  return (
    <div className="mb-3">
      {uploadElement}
      {!imagePreview && !isEditModal && (
        <div
          className={`file-drop-area mb-3 ${
            imagePreview || editedImg ? "py-3" : ""
          }`}
        >
          <div className="file-drop-icon ai-upload"></div>
          <span className="file-drop-message mb-0">
            {isMobile
              ? t(`click_here_to_upload`)
              : t(`drag_and_drop_here_to_upload`)}
          </span>
          <input
            accept="image/png, image/gif, image/jpeg"
            type="file"
            onChange={onUploadBtnClick}
            onClick={(event) => {
              // @ts-ignore
              event.target.value = null;
            }}
            className="file-drop-input"
          />
          <div className="invalid-feedback text-center">
            {t(errors.preview_image?.message as string)}
          </div>
        </div>
      )}
      <div>
        {(imagePreview || editedImg) && (
          <div className="d-flex justify-content-center align-items-center">
            <div className="position-relative">
              <div
                onClick={() => {
                  fileUploadRef.current.click();
                }}
                className="btn-primary px-2 py-1 rounded-lg position-absolute cursor"
                style={{ right: -12, top: -12 }}
              >
                <FiRefreshCw size={18} />
              </div>
              <img
                src={imagePreview ? imagePreview : editedImg}
                className="d-block mx-auto object-fit-cover "
                alt="avatar"
              />
            </div>
          </div>
        )}
      </div>
      <EventImageCropperModal
        image={avatar}
        onImageSubmit={onImageSubmit}
        showCropModal={showImageCropperModal}
        onCropModalClose={handleCloseImageCropperModal}
        onUploadBtnClick={onUploadBtnClick}
      />
    </div>
  );
};

export default memo(Step3);
